// libraries
import React from "react";
import Skeleton from "react-skeleton-loader";

// styles
import styles from "./styles.module.scss";

// assets
import ChevronRightIcon from "src/assets/icons/ChevronRightIcon";

const ShowTimeItem = ({ item }) => {
  return (
    <div className={styles.ticket}>
      <div className={styles.time_info}>
        <h5>{item?.Day ? item?.Day?.substring(0, 3) : <Skeleton />}</h5>
        <h4>
          {item?.Date ? (
            <>
              {item?.Month?.substring(0, 3)} {item?.Date?.substring(0, 2)}
            </>
          ) : (
            <Skeleton />
          )}
        </h4>
        <h5>{item?.Time ? item?.Time : <Skeleton />}</h5>
      </div>
      <div className={styles.location_info}>
        <div>
          <h4>{item?.EventName ? item?.EventName : <Skeleton />}</h4>
          <h5>
            {item?.Description !== undefined ? item?.Description : <Skeleton />}
          </h5>
          <h6>{item?.Location ? item?.Location : <Skeleton />}</h6>
        </div>
        {item?.EventName && <ChevronRightIcon />}
      </div>
    </div>
  );
};

export default ShowTimeItem;
